/* eslint-disable no-unused-vars */
/* eslint-disable jsx-a11y/role-supports-aria-props */
/* eslint-disable no-undef */
import React, { useState } from "react";
import { Collapse } from "react-bootstrap";
import { toast } from "react-hot-toast";
import Select from "react-select";
import Card from "../../../../components/Cards/Card";
import {
  applyTax,
  deliveryMethod,
} from "../../../../utils/helpers/objectHelpers";
import { RemittanceService } from "../../../../utils/services/remittance.service";

function Body({ domainBrand, countries }) {
  const dictionary = domainBrand.domainBrand["languageDictionary"];
  const menuPortalTarget = document.getElementById("root");

  const [open] = useState(false);
  const [tax, setTax] = useState(false);
  const [country, setCountry] = useState({});
  const [taxApply, setTaxApply] = useState({});
  const [delivery, setDelivery] = useState({});
  const [taxRate, setTaxRate] = useState(0);
  const [loading, setLoading] = useState(false);

  const disabled =
    country?.iso3Code !== "" &&
    taxApply?.value !== "" &&
    delivery?.value !== "" &&
    taxRate > 0
      ? false
      : true;

  const updateTaxSettings = async (payload) => {
    setLoading(true);
    try {
      const response = await RemittanceService.taxSetting(payload);
      if (response.data.status === "SUCCESS") {
        setLoading(false);
        toast.success(response.data.message);
        setTaxRate(0);
        setCountry({});
        setTaxApply({});
        setDelivery({});
      } else {
        setLoading(false);
        toast.success(response.data.message);
      }
    } catch (error) {
      return error;
    }
    setLoading(false);
  };

  const payload = {
    selectedCountry: country?.iso3Code,
    chargeCategory: delivery?.value,
    taxOption: taxApply?.value,
    taxPercent: taxRate,
  };

  return (
    <div className="app-content hor-content">
      <div className="container">
        <div className="page-header">
          <div>
            <h1 className="page-title">
              {dictionary ? dictionary["title_vat_settings"] : "Tax Settings"}
            </h1>
          </div>
        </div>

        <div className="row row-sm">
          <div className="col-lg-12 col-md-12">
            <Card>
              <ul className="list-group">
                <li
                  className="list-group-item collapse-text text-uppercase fw-bold"
                  onClick={() => setTax(!tax)}
                  aria-controls="example-collapse-text"
                  aria-expanded={open}
                  style={{ cursor: "pointer", borderBottom: "0px solid" }}
                >
                  {tax ? (
                    <i className="fa fa-minus" aria-hidden="true" />
                  ) : (
                    <i className="fa fa-plus" aria-hidden="true" />
                  )}{" "}
                  &nbsp;
                  {dictionary
                    ? dictionary["title_vat_settings"]
                    : "Tax Settings"}
                </li>
                <Collapse in={tax}>
                  <div id="example-collapse-text" className="px-3">
                    <label>
                      {dictionary
                        ? dictionary["para_tax_settings_description"]
                        : `Tax is based on sending country and sending currency. In current system, the selected percentage will applied on all sending currencies.`}
                    </label>
                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6 mb-3">
                        <label>
                          {dictionary
                            ? dictionary["para_origin_country"]
                            : "Origin Country"}
                        </label>
                        <Select
                          options={countries}
                          isClearable={false}
                          isSearchable={true}
                          maxMenuHeight={250}
                          menuPlacement="bottom"
                          menuPortalTarget={menuPortalTarget}
                          name="country"
                          value={country}
                          onChange={(option) => setCountry(option)}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 mb-3">
                        <label>
                          {dictionary
                            ? dictionary["l_vat_option"]
                            : "Apply Tax On"}
                        </label>
                        <Select
                          options={applyTax()}
                          isClearable={false}
                          isSearchable={true}
                          maxMenuHeight={250}
                          menuPlacement="bottom"
                          menuPortalTarget={menuPortalTarget}
                          name="apply-tax"
                          value={taxApply}
                          onChange={(option) => setTaxApply(option)}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 mb-3">
                        <label>
                          {dictionary
                            ? dictionary["l_charge_category"]
                            : "Fee Category"}
                        </label>
                        <Select
                          options={deliveryMethod()}
                          isClearable={false}
                          isSearchable={true}
                          maxMenuHeight={250}
                          menuPlacement="bottom"
                          menuPortalTarget={menuPortalTarget}
                          name="apply-tax"
                          value={delivery}
                          onChange={(option) => setDelivery(option)}
                        />
                      </div>

                      <div className="col-lg-6 col-md-6 mb-3">
                        <label>
                          {dictionary ? dictionary["l_vat_rate"] : "Tax Rate"}
                          (%)
                        </label>
                        <input
                          className="form-control"
                          value={taxRate}
                          onChange={(e) => setTaxRate(e.target.value)}
                          type={"number"}
                          id="taxrate"
                          name="taxrate"
                        />
                      </div>
                    </div>

                    <div className="form-row py-4">
                      <div className="col-lg-6 col-md-6 mb-3" />
                      <div className="col-lg-6 col-md-6 mb-3 float-end">
                        <button
                          onClick={() => updateTaxSettings(payload)}
                          className="login100-form-btn btn-primary fw-bold text-uppercase"
                          disabled={disabled}
                          type={"button"}
                        >
                          {loading ? (
                            <>
                              <i className="fa fa-spinner fa-spin" />
                            </>
                          ) : (
                            `${dictionary ? dictionary["b_update"] : "UPDATE"}`
                          )}
                        </button>
                      </div>
                    </div>
                  </div>
                </Collapse>
              </ul>
            </Card>
          </div>
        </div>
      </div>
    </div>
  );
}

export default Body;
